import script from "./job_list.vue?vue&type=script&setup=true&lang=js"
export * from "./job_list.vue?vue&type=script&setup=true&lang=js"

import "./job_list.vue?vue&type=style&index=0&id=2f90c080&lang=css"

const __exports__ = script;

export default __exports__